import $ from 'jquery';
import Swiper from 'swiper/bundle';

const initializeBlock = function ($block) {
    new Swiper($block.find('.accompaniments-block__slider')[0], {
        slidesPerView: 1.2,
        navigation: {
            nextEl: '.accompaniments-block__nav--next',
            prevEl: '.accompaniments-block__nav--prev',
        },
        watchOverflow: true,
        grid: {
            rows: 1,
            fill: 'row',
        },
        breakpoints: {
            480: {
                slidesPerView: 2.2,
            },
            600: {
                slidesPerView: 3.1,
            },
            992: {
                slidesPerView: 4,
            },
            1800: {
                slidesPerView: 5,
            },
        },
    });
};

$('.accompaniments-block--slider').each(function () {
    initializeBlock($(this));
});
